import { bool, func, shape, string } from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { fetchCardData, fetchYscTransactionLimit, updateYscTransactionLimits } from './actions';
import { select_card_data } from '../NetworkCards/selectors';
import { fetchYscTransaction, isTransactionLimitsLoading, updateYscTransaction } from './selectors';

const YscTransactionLimitsPropTypes = {
  isTransactionLimitsLoading: bool.isRequired,
  cardData: shape({}).isRequired,
  location: shape({}).isRequired,
  fetchYscLimits: shape({}).isRequired,
  updateYscLimits: shape({}).isRequired,
  match: shape({
    params: shape({
      id: string,
      type: string,
    }),
  }).isRequired,
  onFetchCardData: func.isRequired,
  onFetchYscTransactionLimit: func.isRequired,
  onUpdateYscTransactionLimits: func.isRequired,
};


const YscTransactionLimitsMapDispatchToProps = (dispatch) => ({
  onFetchCardData: (payload) => dispatch(fetchCardData(payload)),
  onFetchYscTransactionLimit: (payload) => dispatch(fetchYscTransactionLimit(payload)),
  onUpdateYscTransactionLimits: (payload) => dispatch(updateYscTransactionLimits(payload)),
});

const YscTransactionLimitsMapStateToProps = createStructuredSelector({
  cardData: select_card_data(),
  fetchYscLimits: fetchYscTransaction(),
  updateYscLimits: updateYscTransaction(),
  isTransactionLimitsLoading: isTransactionLimitsLoading(),
});

export { YscTransactionLimitsPropTypes, YscTransactionLimitsMapDispatchToProps, YscTransactionLimitsMapStateToProps };



// WEBPACK FOOTER //
// client/containers/YscTransactionLimits/YscTransactionLimitsDatahandler.js